/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Aerobic_Te_Friendly_NameInputs */

const en_exp_aerobic_te_friendly_name = /** @type {(inputs: Exp_Aerobic_Te_Friendly_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aerobic Training Effect`)
};

const de_exp_aerobic_te_friendly_name = /** @type {(inputs: Exp_Aerobic_Te_Friendly_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aerober Trainingseffekt`)
};

/**
* | output |
* | --- |
* | "Aerobic Training Effect" |
*
* @param {Exp_Aerobic_Te_Friendly_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_aerobic_te_friendly_name = /** @type {((inputs?: Exp_Aerobic_Te_Friendly_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Aerobic_Te_Friendly_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_aerobic_te_friendly_name(inputs)
	return de_exp_aerobic_te_friendly_name(inputs)
});